<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          @click="newTransfer"
          v-if="auth.can('ADD_VIREMENT')"
        >
          Nouveau Virement
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#transferScheduleModal"
          @click="openSchedule"
        >
          Afficher les fréquences des clients
          <i class="flaticon-calendar position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
          @change="getRecords()"
          @input="getRecords"
          v-model="users.searchTerm"
        />

        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="columns" :rows="rows" responsive>
        <template v-slot:emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <span v-if="props.column.field === 'ref'" class="text-nowrap">
            <b>{{ props.row.ref }}</b>
          </span>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <template v-if="props.row.created_at != null"
              >{{ getDate(props.row.created_at) }}<br
            /></template>
            {{ props.row.c_by_name }}
          </span>
          <span v-else-if="props.column.field === 'p_time'" class="text-nowrap">
            <template v-if="props.row.p_time != null"
              >{{ getDate(props.row.p_time) }}<br
            /></template>
            {{ props.row.p_by_name }}
          </span>
          <span
            v-else-if="props.column.field === 'total_to_send'"
            class="text-nowrap"
          >
            {{ props.row.total_to_send }} {{ $devis }}
          </span>

          <span
            v-else-if="props.column.field === 'total_inv'"
            class="text-nowrap"
          >
            {{ props.row.total_inv }}
          </span>
          <div
            v-else-if="props.column.field === 'client_transfer_frequencies'"
            class="small freq-cell"
          >
            <a
              href="#"
              class="freq-toggle"
              @click.prevent="toggleFrequencies(props.row.id)"
            >
              {{ freq[props.row.id]?.open ? "Masquer" : "Voir les fréquences" }}
            </a>
            <template v-if="freq[props.row.id]?.open">
              <div v-if="freq[props.row.id].loading" class="mt-1">
                <span class="spinner-border spinner-border-sm"></span>
              </div>
              <div v-else-if="freq[props.row.id].error" class="mt-1 text-danger">
                Erreur de chargement
              </div>
              <div v-else-if="!freq[props.row.id].groups.length" class="mt-1">-</div>
              <div
                v-for="group in freq[props.row.id].groups"
                v-else
                :key="group.label"
                class="mt-1"
              >
                <span class="badge rounded-pill freq-badge">{{ group.label }}</span>
                <b class="ms-1">{{ group.clients.length }}</b>
                client{{ group.clients.length > 1 ? "s" : "" }}
                <span class="d-block freq-clients">
                  {{ group.clients.join(" · ") }}
                </span>
              </div>
            </template>
          </div>

          <template v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut == 0"
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.statut
              )}`"
              class="text-capitalize"
            >
              Nouveau
            </span>

            <span
              v-else-if="props.row.statut == 1"
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.statut
              )}`"
              class="text-capitalize"
            >
              Payé
            </span>
          </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <router-link
                    class="dropdown-item"
                    :to="`/edit-virements/${props.row.id}/${props.row.ref}`"
                  >
                    <i class="flaticon-edit"></i> Modifier
                  </router-link>
                </li>
                <li v-if="props.row.statut == 0 && props.row.total_inv == 0">
                  <button class="dropdown-item" @click="DestroyVire(props.row)">
                    <i class="flaticon-delete"></i> Supprimer
                  </button>
                </li>
                <li
                  v-if="
                    props.row.statut == 0 &&
                    props.row.total_inv != 0 &&
                    props.row.total_to_send != 0
                  "
                >
                  <button class="dropdown-item" @click="PaidVire(props.row)">
                    <i class="flaticon-check"></i> Payé
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    @click="ExportTransfer(props.row)"
                  >
                    <i class="flaticon-download"></i> Exporter
                  </button>
                </li>
                <li>
                  <button class="dropdown-item" @click="PDFTransfer(props.row)">
                    <i class="flaticon-file"></i> Télécharger
                  </button>
                </li>
              </ul>
            </div>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>

      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="getRecords"
      />
    </div>

    <div class="modal fade" id="transferScheduleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mb-0">Calendrier des virements clients</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-wrap align-items-center gap-2 mb-15">
              <button type="button" class="btn btn-outline-secondary btn-sm" @click="shiftSchedule(-7)">
                &larr; Semaine précédente
              </button>
              <input
                v-model="scheduleStart"
                type="date"
                class="form-control form-control-sm w-auto"
                @change="getSchedule"
              />
              <button type="button" class="btn btn-outline-secondary btn-sm" @click="shiftSchedule(7)">
                Semaine suivante &rarr;
              </button>
              <button type="button" class="btn btn-link btn-sm" @click="resetSchedule">Aujourd'hui</button>
              <small class="text-muted ms-auto">
                Quotidien : lun–sam · 3 fois par semaine : lun, mer, ven · Une fois par semaine : lundi
              </small>
            </div>

            <div v-if="scheduleLoading" class="text-center text-muted py-4">Chargement…</div>
            <div v-else class="row">
              <div class="col-lg-3 mb-15">
                <div class="list-group">
                  <button
                    v-for="day in scheduleDays"
                    :key="day.date"
                    type="button"
                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                    :class="{ active: selectedDay && selectedDay.date === day.date }"
                    @click="selectedDate = day.date"
                  >
                    <span>
                      <b class="text-capitalize">{{ dayName(day.day_iso) }}</b>
                      <span v-if="day.is_today" class="badge text-bg-warning ms-1">Aujourd'hui</span>
                      <br />
                      <small>{{ formatDate(day.date) }}</small>
                    </span>
                    <span class="badge rounded-pill" :class="day.clients_count ? 'text-bg-success' : 'text-bg-light'">
                      {{ day.clients_count }} client(s)
                    </span>
                  </button>
                </div>
              </div>

              <div class="col-lg-9">
                <template v-if="selectedDay">
                  <div class="d-flex flex-wrap justify-content-between mb-10">
                    <h6 class="mb-0">
                      <span class="text-capitalize">{{ dayName(selectedDay.day_iso) }}</span>
                      {{ formatDate(selectedDay.date) }}
                    </h6>
                    <span class="small">
                      {{ selectedDay.clients_count }} client(s) ·
                      {{ selectedDay.invoices_count }} facture(s) ·
                      <b>{{ selectedDay.total_to_send }} {{ $devis }}</b>
                    </span>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-sm align-middle">
                      <thead>
                        <tr>
                          <th>Client</th>
                          <th>Fréquence</th>
                          <th>Factures concernées</th>
                          <th class="text-end">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!selectedDay.clients.length">
                          <td colspan="4" class="text-center text-muted">
                            Aucun client à virer ce jour (ou aucune facture enregistrée en attente).
                          </td>
                        </tr>
                        <tr v-for="client in selectedDay.clients" :key="client.id">
                          <td>
                            <b>{{ client.store || client.name }}</b><br />
                            <small class="text-muted">{{ client.bank }}</small><br />
                            <small style="color: #ff9f43">{{ client.rib }}</small>
                          </td>
                          <td class="text-nowrap">
                            {{ client.frequency_label }}<br />
                            <small class="text-muted">{{ client.days_label }}</small>
                          </td>
                          <td>
                            <div v-for="inv in client.invoices" :key="inv.invoice_ref" class="small text-nowrap">
                              <b>{{ inv.invoice_ref }}</b>
                              — {{ inv.parcels_num }} colis — {{ inv.total_to_send }} {{ $devis }}
                              <span class="text-muted">({{ inv.created_at }})</span>
                            </div>
                          </td>
                          <td class="text-end text-nowrap">
                            <b>{{ client.total_to_send }} {{ $devis }}</b><br />
                            <small class="text-muted">{{ client.invoices_count }} facture(s)</small>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/axios";
import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import moment from "moment";

export default defineComponent({
  name: "InvoiceList",
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const pageLength = ref(10);
    const loading = ref(false);
    // "Frequence par client": fetched from the API only when a row is opened, one transfer at a time
    const freq = reactive({});
    async function toggleFrequencies(id) {
      const entry = freq[id];
      if (entry) {
        entry.open = !entry.open;
        if (!entry.error) return;
      } else {
        freq[id] = { open: true, loading: false, error: false, groups: [] };
      }
      const current = freq[id];
      current.loading = true;
      current.error = false;
      try {
        const res = await api.get("/api/auth/transfer_client_frequencies", {
          params: { transfer_id: id },
        });
        current.groups = res.data.groups;
      } catch (e) {
        current.error = true;
      } finally {
        current.loading = false;
      }
    }
    const columns = [
      { label: "Référence", field: "ref" },
      { label: "Date de création", field: "created_at" },
      { label: "Date de paiement", field: "p_time" },
      { label: "Statut", field: "statut" },
      { label: "Factures", field: "total_inv" },
      { label: "Frequence par client", field: "client_transfer_frequencies" },
      { label: "Total", field: "total_to_send" },
      { label: "Actions", field: "action", width: "180px" },
    ];
    const rows = ref([]);
    const users = ref({
      searchTerm: "",
      searchStatut: "",
      searchDateCS: "",
      searchDateCE: "",
      searchDatePS: "",
      searchDatePE: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);
    const status_filter = ref("");
    const debounceTimer = ref(null);

    function resolveUserStatusVariant(status) {
      if (status === 0) return "danger";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "warning";
    }

    function newTransfer() {
      const data = new FormData();
      data.append("user_id", user.id);
      data.append("user_name", user.name || "");
      loading.value = true;
      api
        .post(`/api/auth/add_transfer`, data)
        .then((res) => {
          loading.value = false;
          if (res.data.message === "success") {
            // Use router from vue-router composable
            window.location.href = `/edit-virements/${res.data.data?.id}/${res.data.data?.ref}`;
          }
        })
        .catch(() => {
          showToast("Something went wrong! Please try again", "error");
        });
    }
    function getRecords(page = 1) {
      loading.value = true;
      users.value.current_page = page;
      api
        .get(`/api/auth/transfers_list`, {
          params: {
            searchTerm: users.value.searchTerm,
            searchStatut: users.value.searchStatut,
            searchDateCS: users.value.searchDateCS,
            searchDateCE: users.value.searchDateCE,
            searchDatePS: users.value.searchDatePS,
            searchDatePE: users.value.searchDatePE,
            page: users.value.current_page,
            per_page: users.value.per_page,
          },
        })
        .then((response) => {
          rows.value = response.data.users.data;
          users.value = response.data.users;
        })
        .finally(() => {
          loading.value = false;
        });
    }

    function DestroyVire(row) {
      api.post(`/api/auth/destroy_trnsf/${row.id}`).then((res) => {
        if (res.data.message === "success") {
          getRecords();
          showToast("Virement est supprimé", "success");
        } else {
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      });
    }

    function PaidVire(row) {
      // You can use a modal here if needed
      api
        .post(`/api/auth/paid_trnsf/${row.id}`, {
          UserID: user.id,
          user_name: user.name || "admin",
        })
        .then((res) => {
          if (res.data.message === "success") {
            getRecords();
          } else {
            showToast("Erreur lors du paiement", "error");
          }
        });
    }

    function ExportTransfer(row) {
      api
        .get(`/api/auth/ExportTransfer/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          const fileURL = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = `${row.ref}.xlsx`;
          fileLink.click();
        });
    }

    function PDFTransfer(row) {
      api
        .get(`/api/auth/TransfertPDF/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function filter() {
      users.value.searchStatut = status_filter.value;
      getRecords();
    }

    function Removefilter() {
      users.value.searchStatut = "";
      users.value.searchDateCS = "";
      users.value.searchDateCE = "";
      users.value.searchDatePS = "";
      users.value.searchDatePE = "";
      users.value.searchTerm = "";
      status_filter.value = "";
      getRecords();
    }

    function handleInput(e) {
      clearTimeout(debounceTimer.value);
      debounceTimer.value = setTimeout(() => {
        users.value.searchTerm = e.target.value;
        filter();
      }, 500);
    }

    function getDate(str) {
      // if (!str) return "";
      // const date = new Date(str);
      // return date.toLocaleDateString();
       if (str) return moment(String(str)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    // Transfer calendar (clients due a transfer per day, from their frequency)
    const scheduleStart = ref(moment().format("YYYY-MM-DD"));
    const scheduleDays = ref([]);
    const scheduleLoading = ref(false);
    const selectedDate = ref("");
    const selectedDay = computed(
      () => scheduleDays.value.find((d) => d.date === selectedDate.value) || scheduleDays.value[0] || null
    );

    function getSchedule() {
      if (!scheduleStart.value) scheduleStart.value = moment().format("YYYY-MM-DD");
      scheduleLoading.value = true;
      api
        .get(`/api/auth/transfer_schedule`, { params: { start: scheduleStart.value, days: 7 } })
        .then((res) => {
          scheduleDays.value = res.data.days || [];
          if (!scheduleDays.value.some((d) => d.date === selectedDate.value)) {
            selectedDate.value = scheduleDays.value[0]?.date || "";
          }
        })
        .catch(() => {
          showToast("Impossible de charger le calendrier des virements", "error");
        })
        .finally(() => {
          scheduleLoading.value = false;
        });
    }

    function openSchedule() {
      getSchedule();
    }

    function shiftSchedule(days) {
      scheduleStart.value = moment(scheduleStart.value).add(days, "days").format("YYYY-MM-DD");
      getSchedule();
    }

    function resetSchedule() {
      scheduleStart.value = moment().format("YYYY-MM-DD");
      selectedDate.value = scheduleStart.value;
      getSchedule();
    }

    function dayName(isoDay) {
      return ["", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"][isoDay] || "";
    }

    function formatDate(str) {
      return moment(str).format("DD/MM/YYYY");
    }

    onMounted(() => {
      getRecords();
    });

    return {
      freq,
      toggleFrequencies,
      auth,
      user,
      columns,
      rows,
      users,
      offset,
      status_filter,
      resolveUserStatusVariant,
      getRecords,
      DestroyVire,
      PaidVire,
      ExportTransfer,
      PDFTransfer,
      convert,
      filter,
      Removefilter,
      handleInput,
      getDate,
      loading,
      pageLength,
      newTransfer,
      scheduleStart,
      scheduleDays,
      scheduleLoading,
      selectedDate,
      selectedDay,
      getSchedule,
      openSchedule,
      shiftSchedule,
      resetSchedule,
      dayName,
      formatDate,
    };
  },
});
</script>
<style scoped>
.freq-cell {
  min-width: 190px;
  max-width: 340px;
  line-height: 1.5;
}
.freq-badge {
  background: rgba(var(--brand-accent-rgb), 0.12);
  color: var(--brand-accent-text);
  font-weight: 600;
}
.freq-clients {
  margin-top: 2px;
  color: var(--bs-secondary-color, #6c757d);
  word-break: break-word;
}
.freq-toggle {
  font-size: 12px;
  color: var(--brand-accent-text);
  text-decoration: underline;
}
</style>
